import {serviceEventCloseoutPolicies, ServiceEventCloseoutPolicy} from "@ots-frontend/ots-data";
import {BaseDbCodeSelect, DbCodeSelectProps} from "../base-db-code-select";

type Props = DbCodeSelectProps<ServiceEventCloseoutPolicy>;

export const ServiceEventCloseoutPolicySelect = (props: Props) => {
  const {options = serviceEventCloseoutPolicies, ...rest} = props;
  return <BaseDbCodeSelect options={options} {...rest} />;
};
